import $ from "jquery";
import BD_Component from "../core/bd-component";
import compile from "../utils/handlerbars-helper";

export class RoomNoChallenge extends BD_Component {
    constructor() {
        super();

        this.id = "no_challenge";
        this.templateID = "no_challenge-template";

        this.elms = {
            //
        };

        this._events = this.getEvents();

        this._data = {};
        this._questions = [];
        this._labels = [];
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        return [];
    }

    beforeInit() {
        this.render();
        this.setGameState();
    }

    getModifiedData() {
        const modified = { ...this._data };

        const hintHotspots = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";

        const _hints = this._data.hints.map((hint, i) => {
            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const modifiedData = {
            ...modified,
            hints: _hints,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);
    }

    setGameState() {
        return false;
    }
}
